export enum CodeProduitType {
  CEMS = 'CEMS',
  CIMS = 'CIMS',
  ATDN = 'ATDN', // GPA
  GFD = 'GFD',
  CEGP = 'CEGP',
  PERI = 'PERI'
}
